import { useQuery } from '@tanstack/react-query';

import { useFleet } from '../hooks/useFleet';

export const useBusStopAutocomplete = () => {
  const fleet = useFleet();
  const queryKey = ['busStops', fleet.uuid];

  const path = process.env.REACT_APP_STATIC_PATH || '';


  const queryFn = (): Promise<{name: string; id: string}[]> => {
    return fetch(`${path}/busStopIDs/${fleet.uuid}.json`).then(r => r.json(), () => []);
  }

  return useQuery({
    queryKey,
    queryFn,
    enabled: !!fleet.uuid,
  });
};
